




import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WHomeMenu extends BaseComponent {
	homeMenu() {
		return [
			[
				{
					title: "SX_LANG_SECTORS",
					icon: "fa-stream",
					link: "/sectors"
				},
				{
					title: "SX_LANG_COMPANIES_FIND",
					icon: "fa-search-dollar",
					link: "/companies/search"
				},
				{
					title: "SX_LANG_SURVEYS_FIND",
					icon: "fa-search",
					link: "/surveys/search"
				},
				{
					title: "SX_LANG_ACCOUNT",
					icon: "fa-user-alt",
					link: "/account"
				}
			],
			[
				{
					title: "SX_LANG_ABOUT",
					icon: "fa-info-circle",
					link: "/about"
				}
				//{
				//	title: "SX_LANG_SHARE",
				//	icon: "fa-share-alt",
				//	link: "/share"
				//}
			]
		];
	}
}
